import { setServiceUid, publicInstance } from './index';

export const fetchLineTypes = async () => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(`service/${serviceUid}/line/line-type`);
	} catch (error) {
		console.error(error);
	}
};

export const fetchLineList = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(`service/${serviceUid}/line`, {
			params,
		});
	} catch (error) {
		console.error(error);
	}
};

export const fetchStationList = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(
			`service/${serviceUid}/line/turn/${params.lineTurnUid}/station`,
			{ params: params.params },
		);
	} catch (error) {
		console.error(error);
	}
};

export const fetchStationPosition = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(
			`service/${serviceUid}/line/station/${params.stationUid}`,
		);
	} catch (error) {
		console.error(error);
	}
};

export const fetchAllocList = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(
			`service/${serviceUid}/line/turn/${params.lineTurnUid}/alloc`,
			{
				params: params.params,
			},
		);
	} catch (error) {
		console.error(error);
	}
};
